<template>
  <v-dialog v-model="isVisible" max-width="400px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" fab dark small color="primary">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-container>
        <v-card-title>Add user</v-card-title>
        <v-card-text>
          <v-text-field
            color="primary"
            label="First name"
            required
            v-model="user.firstname"
            :error-messages="UserFirstNameErrors"
            @input="$v.user.firstname.$touch()"
            @blur="$v.user.firstname.$touch()"
          ></v-text-field>
          <v-text-field
            color="primary"
            label="Last name"
            required
            v-model="user.lastname"
            :error-messages="UserLastNameErrors"
            @input="$v.user.lastname.$touch()"
            @blur="$v.user.lastname.$touch()"
          ></v-text-field>
          <v-text-field
            color="primary"
            label="E-mail"
            required
            v-model="user.email"
            :error-messages="UserEmailErrors"
            @input="$v.user.email.$touch()"
            @blur="$v.user.email.$touch()"
          ></v-text-field>
          <v-select
            v-model="user.group"
            :items="groupsToList"
            item-text="groupName"
            item-value="id"
            return-object
            required
            :error-messages="UserGroupErrors"
            @input="$v.user.group.$touch()"
            @blur="$v.user.group.$touch()"
            label="Group"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-row justify="space-around">
            <v-btn :disabled="this.$v.$invalid" light color="primary" @click="save()">
              <v-icon dark>mdi-content-save</v-icon>
            </v-btn>
            <v-btn dark color="primary" @click="cancel">cancel</v-btn>
          </v-row>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "AddNewUser",
  props: ["groups"],
  data: () => ({
    isVisible: false,
    user: {
      firstname: "",
      lastname: "",
      email: "",
      group: ""
    },
  }),
  validations: {
    user: {
      firstname: { required },
      lastname: { required },
      email: { email, required },
      group: { required }
    }
  },
  computed: {
    groupsToList() {
      return this.groups.filter(gr => gr.groupName  !== 'Administrator');
    },
    UserFirstNameErrors() {
      const errors = [];
      if (!this.$v.user.firstname.$dirty) return errors;
      !this.$v.user.firstname.required && errors.push("Firstname is required.");
      return errors;
    },
    UserLastNameErrors() {
      const errors = [];
      if (!this.$v.user.lastname.$dirty) return errors;
      !this.$v.user.lastname.required && errors.push("Lastname is required.");
      return errors;
    },
    UserEmailErrors() {
      const errors = [];
      if (!this.$v.user.email.$dirty) return errors;
      !this.$v.user.email.required && errors.push("E-mail is required");
      !this.$v.user.email.email && errors.push("Must be valid e-mail");

      return errors;
    },
    UserGroupErrors() {
      const errors = [];
      if (!this.$v.user.group.$dirty) return errors;
      !this.$v.user.group.required && errors.push("Group is required");
      return errors;
    }
  },
  methods: {
    cancel() {
      this.$v.$reset();
      this.user = {};
      this.isVisible = false;
    },
    save() {
      this.isVisible = false;
      
      let mutation = `mutation createUser($user: CreateUser!) {
                                createUser(user: $user) {
                                     id
                                    firstname,
                                    lastname,
                                    group{
                                      id,
                                      groupName
                                    }
                                }
                            }`;

      axios
        .post("/graphql", {
          query: mutation,
          variables: {
            user: {
              firstname: this.user.firstname,
              lastname: this.user.lastname,
              emailaddress: this.user.email,
              companyID: this.$store.getters.user.details.companyId,
              userGroupId: this.user.group.id
            }
          }
        })
        .then(result => {
          if (result.data.data.createUser.id) {
            this.user = {};
            this.$emit("addUser", result.data.data.createUser);
            this.showSuccess("User added!");
            this.$v.$reset();
          }
        })
        .catch(error => this.showError(error));
    }
  }
};
</script>

<style>
</style>